import React from 'react';
import Login from '../features/auth/components/Login';

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
